import { render, staticRenderFns } from "./completions.vue?vue&type=template&id=b9cbbe6c&shadow"
import script from "./completions.vue?vue&type=script&lang=js&shadow"
export * from "./completions.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports